import 'raf/polyfill';
import {GatsbyBrowser} from 'gatsby';
// @ts-ignore
// import {createRoot} from 'react-dom/client';
// import {Renderer} from 'react-dom';
import './src/assets/css/main.css';
import myWrapRootElement from './myWrapRootElement';
import myWrapPageElement from './myWrapPageElement';
import {
  resolveRouteContract,
  toMobileDeepLinkValue,
} from './src/utils/deepLinkUtils';

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] =
  myWrapRootElement;

export const wrapPageElement = myWrapPageElement;

// Drives the AppsFlyer Smart Banner's deep_link_value on initial paint and
// every SPA navigation. resolveRouteContract is the single source of truth
// for web→native path mapping; matches what buildOneLink sends so installed
// users and banner clicks land on the same native screen.
export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({location}) => {
  if (typeof window === 'undefined') return;
  const win = window as unknown as {AF?: (...args: unknown[]) => void};
  if (typeof win.AF !== 'function') return;

  try {
    const fullPath = `${location.pathname}${location.search}`;
    const contractPath = resolveRouteContract(fullPath);
    const queryIndex = contractPath.search(/[?#]/);
    const rawPath =
      queryIndex === -1 ? contractPath : contractPath.slice(0, queryIndex);
    const querySuffix = queryIndex === -1 ? '' : contractPath.slice(queryIndex);

    // AppsFlyer Smart Banner V2 expects per-banner overrides under
    // `additionalParams` — sending them under any other key (e.g. `bannerParams`)
    // is silently ignored and the banner falls back to the dashboard default.
    // Ref: https://dev.appsflyer.com/hc/docs/dl_smart_banner_v2
    const additionalParams: Record<string, string> = {
      deep_link_value: toMobileDeepLinkValue(rawPath),
    };
    if (querySuffix) {
      new URLSearchParams(querySuffix.replace(/^[?#]/, '')).forEach(
        (value, key) => {
          additionalParams[`deep_link_${key}`] = value;
        },
      );
    }

    win.AF('banners', 'showBanner', {additionalParams});
  } catch (err) {
    // banner refresh is non-critical
  }
};

//
// Ceci est un patch pour l'erreur sur le build de production avec l'erreur React :
// > Hydration failed because the initial UI does not match what was rendered on the server.
// voir https://github.com/gatsbyjs/gatsby/discussions/31943#discussioncomment-2880513
//
// export const replaceHydrateFunction: GatsbyBrowser['replaceHydrateFunction'] =
//   () => {
//     return ((
//       element:
//         | string
//         | number
//         // | boolean
//         | React.ReactElement<any, string | React.JSXElementConstructor<any>>
//         | Iterable<React.ReactNode>
//         | React.ReactPortal,
//       container: Element | DocumentFragment,
//     ) => {
//       const root = createRoot(container);
//       root.render(element);
//     }) as Renderer;
//   };

export const registerServiceWorker = () => true;
